import { orderService } from "@/services/api/orderService";
import { getFoodPackagingProductsContainer } from "@/utils/productUtils";

/**
 * @note The backend supports only one basket at a time (shared for mealPlan and order). <br/>
 * Always use this single basket instance in the frontend as well. <br/>
 * Do not maintain separate baskets for mealPlan and order in the frontend. <br/>
 */
export default {
  data() {
    return {
      // Removed basketTile to avoid conflict with prop in components
      isLoading: false
    };
  },
  computed: {
    // Get basket items
    basketItems() {
      // Use prop if available, fallback to local data (if any)
      return this.basketTile?.basketItems || [];
    },
  },
  methods: {
    async getBasketTile(orderType, options = {}, productId = null) {
      try {
        this.isLoading = true;
        const result = await orderService.calculateOrder(orderType, options);

        if (result.exception) {
          this.showError("exceptionMessage");
          return null;
        }
        if (result.errorCode > 0) {
          this.showError(result.errorMsg);
          return null;
        }

        let basketTile = result.basketTile || null;
        if (!basketTile) {
          this.makeToast("danger", this.$t("notification.noProducts"));
          return null;
        }

        // Filter only the product matching `productId`, or keep all if `null`
        const filteredItems = productId
          ? basketTile.basketItems.filter(item => item.prodId === productId)
          : basketTile.basketItems;

        // Recalculate basket total
        const newTotal = filteredItems.reduce((sum, item) => sum + item.totalPrice, 0);

        // Return basketTile with filtered items and recalculated totals
        const foodPackagingProducts = getFoodPackagingProductsContainer(result) || getFoodPackagingProductsContainer(basketTile);

        const updatedBasketTile = {
          ...basketTile,
          orderType: result.orderType,
          basketItems: filteredItems,
          basketTotal: newTotal,
          comment: result.comment,
          promotionBarcode: result.promotionBarcode,
          foodPackagingProducts: foodPackagingProducts || undefined,
        };

        // Do not assign to this.basketTile here, just return the value
        console.debug("BasketTile:", updatedBasketTile);
        return updatedBasketTile;
      } catch (error) {
        this.makeToast("danger", this.$t("error.general"));
        return null;
      } finally {
        this.isLoading = false;
      }
    },

    showError(messageKey) {
      this.makeToast("danger", this.$t(messageKey));
    }
  }
};
